import React from 'react';
import { Box, Tabs, Tab, useTheme } from '@mui/material';
import { Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import MemoryIcon from '@mui/icons-material/Memory';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import FenceIcon from '@mui/icons-material/Fence';
import WarningIcon from '@mui/icons-material/Warning';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import RouteIcon from '@mui/icons-material/Route';

import CanPayloadDecoder from './telematics/CanPayloadDecoder';
import TripSegmentation from './telematics/TripSegmentation';
import GeofenceVisualizer from './telematics/GeofenceVisualizer';
import HarshBrakingAnalysis from './telematics/HarshBrakingAnalysis';
import SpeedAnomalyDetection from './telematics/SpeedAnomalyDetection';
import RouteSnappingPlayground from './telematics/RouteSnappingPlayground';

const telematicsTools = [
  { name: 'CAN Decoder', path: 'can-decoder', icon: <MemoryIcon fontSize="small" />, component: CanPayloadDecoder },
  { name: 'Trip Segmentation', path: 'trip-segmentation', icon: <ContentCutIcon fontSize="small" />, component: TripSegmentation },
  { name: 'Geofence Visualizer', path: 'geofence-visualizer', icon: <FenceIcon fontSize="small" />, component: GeofenceVisualizer },
  { name: 'Harsh Braking', path: 'harsh-braking', icon: <WarningIcon fontSize="small" />, component: HarshBrakingAnalysis },
  { name: 'Speed Anomalies', path: 'speed-anomalies', icon: <TrendingUpIcon fontSize="small" />, component: SpeedAnomalyDetection },
  { name: 'Route Snapping', path: 'route-snapping', icon: <RouteIcon fontSize="small" />, component: RouteSnappingPlayground },
];

function TelematicsApp() {
  const theme = useTheme();
  const location = useLocation();
  const currentTab = telematicsTools.findIndex(t => location.pathname.includes(t.path));
  const activeTab = currentTab === -1 ? 0 : currentTab;

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {/* Horizontal sub-tabs at top */}
      <Box sx={{
        borderBottom: `1px solid ${theme.palette.divider}`,
        bgcolor: 'background.paper',
        flexShrink: 0,
      }}>
        <Tabs
          value={activeTab}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            minHeight: 42,
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '0.78rem',
              minHeight: 42,
              py: 0,
            },
            '& .MuiTabs-indicator': {
              height: 3,
              borderRadius: '3px 3px 0 0',
              bgcolor: '#6366f1',
            },
          }}
        >
          {telematicsTools.map((tool, i) => (
            <Tab
              key={tool.path}
              component={Link}
              to={tool.path}
              icon={tool.icon}
              iconPosition="start"
              label={tool.name}
              id={`telematics-tab-${i}`}
              aria-controls={`telematics-tabpanel-${i}`}
            />
          ))}
        </Tabs>
      </Box>

      {/* Content */}
      <Box sx={{ flexGrow: 1, minHeight: 0, overflow: 'hidden' }}>
        <Routes>
          <Route path="/" element={<Navigate to={telematicsTools[0].path} replace />} />
          {telematicsTools.map(tool => (
            <Route key={tool.path} path={tool.path} element={<tool.component />} />
          ))}
        </Routes>
      </Box>
    </Box>
  );
}

export default TelematicsApp;
